import iconWhite from '../assets/marca/icone-branco.svg';
import iconMain from '../assets/marca/icone-principal.svg';
import wordmarkWhite from '../assets/marca/logotipo-branco.svg';
import wordmarkBlack from '../assets/marca/logotipo-preto.svg';
import wordmarkMain from '../assets/marca/logotipo-principal.svg';
import { cx } from '../cx';

export type LogoGround = 'dark' | 'red' | 'light';

// Regras do Manual de Normas (p. 12 e 14): fundo preto -> versao principal;
// fundo vermelho -> versao branca (nunca preta); fundo branco -> logotipo preto
// e icone principal. Sem sombras, contornos nem outras cores.
const files = {
  wordmark: { dark: wordmarkMain, red: wordmarkWhite, light: wordmarkBlack },
  icon: { dark: iconMain, red: iconWhite, light: iconMain },
} as const;

// Caixa e margem dos antigos PNG (1200x155 e 320x444, com ~26 px de margem a
// volta). Os SVG nao tem margem; mantemos a mesma caixa para nada mudar de
// sitio nas paginas.
const sizes = {
  wordmark: { width: 1200, height: 155, padX: 26, padY: 25 },
  icon: { width: 320, height: 444, padX: 26, padY: 25 },
} as const;

export type LogoProps = {
  /** `wordmark`: «GROW UP ESPORTS» horizontal; `icon`: a chama com «UP». */
  variant?: 'wordmark' | 'icon';
  /** Cor do fundo onde o logotipo assenta (escolhe a versao certa). */
  ground?: LogoGround;
  /** Altura em pixeis; a largura acompanha. */
  height?: number;
  /** Texto alternativo; vazio quando ao lado ja esta escrito «Grow uP». */
  alt?: string;
  className?: string;
};

/**
 * O logotipo oficial, a partir dos vetores da marca (`src/assets/marca/`).
 */
export function Logo({
  variant = 'wordmark',
  ground = 'dark',
  height = variant === 'wordmark' ? 24 : 40,
  alt = 'Grow uP Esports',
  className,
}: LogoProps) {
  const size = sizes[variant];
  const width = Math.round((size.width / size.height) * height);
  const k = height / size.height;
  return (
    <img
      src={files[variant][ground]}
      width={width}
      height={height}
      alt={alt}
      style={{ padding: `${(size.padY * k).toFixed(2)}px ${(size.padX * k).toFixed(2)}px` }}
      className={cx('box-border block shrink-0 select-none object-contain', className)}
      draggable={false}
    />
  );
}
